import Box from '@mui/material/Box';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { IReduxState } from '../../../../store';
import CustomListe from './CustomListe';
import Search from './Search';

interface IAttribuerDroitProps {
    rightsChecked: any;
    setRightsChecked: (x: any) => void;
}


export default function AttribuerDroit(props: IAttribuerDroitProps) {
    const { rightsChecked, setRightsChecked } = props
    const [localDroits, setLocalDroits] = useState(useSelector((state: IReduxState) => state.droits).droits)
    const [objModuleDroit, setObjModuleDroit] = useState({})
    const [objSousModuleDroit, setObjSousModuleDroit] = useState({})
    

    return (
        <>
            <Search
                objModuleDroit={objModuleDroit}
                setObjModuleDroit={setObjModuleDroit}
                objSousModuleDroit={objSousModuleDroit}
                setObjSousModuleDroit={setObjSousModuleDroit}
                setLocalDroits={setLocalDroits}
                localDroits={localDroits}
            />
            <Box style={{ width: '100%', overflow: "auto", background: 'background.paper'}}>
                <CustomListe
                    localDroits={localDroits}
                    rightsChecked={rightsChecked}
                    setRightsChecked={setRightsChecked}
                />
            </Box>
        </>
    );
}
